export interface PayRuleClass {
    AccountPayRuleId: number
    AccountPayRuleName: string
    MaximumBillableHours: number
    AllowOvertime: boolean
    AccountWorkingDayTypeId: string
    AllowWeekendsasOvertime: boolean
    WeekendOvertimeRate: number
    AllowHolidayasOvertime: boolean
    HolidayOvertimeRate: number
    CreatedOn: Date | undefined
    CreatedByEmployeeId: number
    ModifiedOn: Date | undefined
    ModifiedByEmployeeId: number
    IsDisabled: boolean
    IsDeleted: boolean
    AccountId: number
    isSelected: number
    AccountPayCodeId:number
    Name:string
}

export interface PayRuleDetailClass {
AccountPayRuleDetailId: number
AccountPayRuleId: number
AccountPayCodeId: number
Hours: number
CreatedOn: Date | undefined
CreatedByEmployeeId: number
ModifiedOn: Date | undefined
ModifiedByEmployeeId: number
IsDisabled: boolean
IsDeleted: boolean
}

export const payRuleInitialsForAdd = {
    AccountId: 0,
    AccountPayRuleName: "",
    MaximumBillableHours: 0,
    AllowOvertime: false,
    AccountWorkingDayTypeId: "",
    AllowWeekendsasOvertime: false,
    WeekendOvertimeRate: 0,
    AllowHolidayasOvertime: false,
    HolidayOvertimeRate: 0,
    IsDisabled: false,
    IsDeleted: false,
    AccountPayRuleDetailId: 0,
    AccountPayCodeId: 0,
    Hours: 0
}

export const payRuleInitialsForUpdate = {
    AccountPayRuleId: 0,
    AccountId: 0,
    AccountPayRuleName: "",
    MaximumBillableHours: 0,
    AllowOvertime: false,
    AccountWorkingDayTypeId: "",
    AllowWeekendsasOvertime: false,
    WeekendOvertimeRate: 0,
    AllowHolidayasOvertime: false,
    HolidayOvertimeRate: 0,
    IsDisabled: false,
    IsDeleted: false,
    AccountPayRuleDetailId: 0,
    AccountPayCodeId: 0,
    Hours: 0
}

